import { Result } from "@praha/byethrow"

export function tryAsync<T, E, U>(
  p: Promise<T>,
  opts: { catch?: (e: unknown) => E; map: (v: T) => U },
): Result.ResultAsync<U, E>
export function tryAsync<T, E = unknown>(
  p: Promise<T>,
  opts?: { catch?: (e: unknown) => E },
): Result.ResultAsync<T, E>
export function tryAsync<T, E, U>(
  p: Promise<T>,
  opts: { catch?: (e: unknown) => E; map?: (v: T) => U } = {},
) {
  const base = Result.try({
    try: () => p,
    catch: opts.catch ?? ((e) => e as E),
  })
  return opts.map ? Result.pipe(base, Result.map(opts.map)) : base
}
